var _path, _rect, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMediaNav = function SvgMediaNav(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00741 4.80857C3.00741 4.00025 3.91669 3.52593 4.57961 3.98845L13.3094 10.0793C13.8798 10.4773 13.8798 11.3216 13.3094 11.7195L4.57961 17.8104C3.91669 18.2729 3.00741 17.7986 3.00741 16.9903L3.00741 4.80857Z",
    fill: "#F5F4EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 19.1567,
    width: 23,
    height: 3,
    rx: 1.5,
    fill: "#A5A497"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24.1567,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#CDCCBB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 29.1567,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#8F8F83"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3.15674,
    width: 16,
    height: 14,
    rx: 3,
    fill: "#78786D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.1567V23.1567C30 24.8136 28.6569 26.1567 27 26.1567H23",
    stroke: "white",
    strokeDasharray: "1 1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMediaNav);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNSAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMDA3NDEgNC44MDg1N0MzLjAwNzQxIDQuMDAwMjUgMy45MTY2OSAzLjUyNTkzIDQuNTc5NjEgMy45ODg0NUwxMy4zMDk0IDEwLjA3OTNDMTMuODc5OCAxMC40NzczIDEzLjg3OTggMTEuMzIxNiAxMy4zMDk0IDExLjcxOTVMNC41Nzk2MSAxNy44MTA0QzMuOTE2NjkgMTguMjcyOSAzLjAwNzQxIDE3Ljc5ODYgMy4wMDc0MSAxNi45OTAzTDMuMDA3NDEgNC44MDg1N1oiIGZpbGw9IiNGNUY0RUIiLz4KPHJlY3QgeD0iMyIgeT0iMTkuMTU2NyIgd2lkdGg9IjIzIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9IiNBNUE0OTciLz4KPHJlY3QgeD0iMyIgeT0iMjQuMTU2NyIgd2lkdGg9IjE3IiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9IiNDRENDQkIiLz4KPHJlY3QgeD0iMyIgeT0iMjkuMTU2NyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjMiIHJ4PSIxLjUiIGZpbGw9IiM4RjhGODMiLz4KPHJlY3QgeD0iMTYiIHk9IjMuMTU2NzQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgcng9IjMiIGZpbGw9IiM3ODc4NkQiLz4KPHBhdGggZD0iTTMwIDEzLjE1NjdWMjMuMTU2N0MzMCAyNC44MTM2IDI4LjY1NjkgMjYuMTU2NyAyNyAyNi4xNTY3SDIzIiBzdHJva2U9IndoaXRlIiBzdHJva2UtZGFzaGFycmF5PSIxIDEiLz4KPC9zdmc+Cg==";